import Cart from '../libs/cart';
import ComponentBase from './base/component-base';
import ComponentInitializer from '../libs/component-initializer';

class CartRemoveButtonComponent extends ComponentBase {
  
  protected itemId: string | null = null;

  constructor(element: HTMLElement) {
    super(element);
    this.init();
  }

  protected init() {
    super.init();
    this.itemId = this.element.dataset.itemId as string;
    this.element.addEventListener('click', () => {
      Cart.remove({
        id: this.itemId || ''
      });
    });
  }
}

ComponentInitializer.initializeComponent('.j-cart-remove-button', CartRemoveButtonComponent);
